(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casa-product-related"]) return;
  try {
    
  (function () {
    var holder = document.querySelector('[data-casa-related]');
    if (!holder || holder.getAttribute('data-loaded') === 'true') return;
    if (holder.querySelector('[data-related-list]')) return;

    var url = holder.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var incoming = doc.querySelector('[data-casa-related]');
        var list = incoming && incoming.querySelector('[data-related-list]');
        var hasItems = list && list.querySelector('li');
        var section = holder.closest('.shopify-section');
        if (hasItems) {
          holder.innerHTML = incoming.innerHTML;
          holder.removeAttribute('hidden');
          holder.setAttribute('data-loaded', 'true');
        } else if (section) {
          section.style.display = 'none';
        }
      })
      .catch(function () {
        var section = holder.closest('.shopify-section');
        if (section) section.style.display = 'none';
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-room-build-levels"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-casa-room-build]').forEach(function(root){
      var buttons=root.querySelectorAll('[data-casa-room-choice]');
      var visuals=root.querySelectorAll('[data-casa-room-visual]');
      var cards=root.querySelectorAll('[data-casa-room-card]');
      function selectPlan(plan){
        root.setAttribute('data-casa-room-active',plan);
        buttons.forEach(function(button){button.setAttribute('aria-pressed',button.dataset.casaRoomChoice===plan?'true':'false')});
        visuals.forEach(function(visual){visual.hidden=visual.dataset.casaRoomVisual!==plan});
        cards.forEach(function(card){card.classList.toggle('is-active',card.dataset.casaRoomCard===plan)});
      }
      buttons.forEach(function(button){button.addEventListener('click',function(){selectPlan(button.dataset.casaRoomChoice)})});
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-washbasin-product-hero"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-casa-washbasin-pdp]');
    if (!root) return;

    var jsonEl = root.querySelector('[data-casa-product-json]');
    var form = root.querySelector('.casa-washbasin-pdp-form');
    var gallery = root.querySelector('[data-casa-gallery]');
    if (!jsonEl || !form) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (error) {
      return;
    }

    var variantInput = form.querySelector('[data-casa-variant-id]');
    var optionNames = product.options || [];

    function variantOptions(variant) {
      return variant.options || [variant.option1, variant.option2, variant.option3];
    }

    function selectedOptions() {
      return (product.options || []).map(function (_name, index) {
        var checked = form.querySelector(
          '[data-casa-option][data-option-position="' + (index + 1) + '"]:checked'
        );
        return checked ? checked.value : null;
      });
    }

    function findVariant() {
      var selected = selectedOptions();
      return (product.variants || []).find(function (variant) {
        var options = variantOptions(variant);
        return selected.every(function (value, index) {
          if (value == null) return true;
          return options[index] === value;
        });
      }) || product.variants[0];
    }

    function optionValue(variant, name) {
      var needle = String(name || '').toLowerCase();
      var index = optionNames.findIndex(function (optionName) {
        return String(optionName || '').toLowerCase() === needle;
      });
      if (index < 0) return '';
      var options = variantOptions(variant);
      return options[index] || '';
    }

    function syncInquiryFields(variant) {
      if (!variant) return;
      var size = optionValue(variant, 'Size');
      var title = variant.title || '';
      if (title === 'Default Title') title = '';
      document.querySelectorAll('[data-casa-inquiry-field]').forEach(function (field) {
        var key = field.getAttribute('data-casa-inquiry-field');
        if (key === 'variant_title') field.value = title;
        if (key === 'size') field.value = size;
        if (key === 'variant_id') field.value = variant.id;
      });
      document.querySelectorAll('[data-casa-inquiry-display]').forEach(function (el) {
        var key = el.getAttribute('data-casa-inquiry-display');
        if (key === 'variant_title') el.textContent = title;
        if (key === 'size') el.textContent = size;
      });
      document.querySelectorAll('[data-casa-inquiry-row]').forEach(function (row) {
        var key = row.getAttribute('data-casa-inquiry-row');
        var value = '';
        if (key === 'variant_title') value = title;
        if (key === 'size') value = size;
        row.hidden = !value;
      });
      if (variantInput) variantInput.value = variant.id;
    }

    function showMedia(mediaId) {
      if (!gallery || !mediaId) return;
      gallery.querySelectorAll('.casa-gallery__slide').forEach(function (slide) {
        var active = String(slide.getAttribute('data-media-id')) === String(mediaId);
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      gallery.querySelectorAll('.casa-gallery__thumb').forEach(function (thumb) {
        var active = String(thumb.getAttribute('data-media-id')) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
    }

    function update(variant) {
      if (!variant) return;
      syncInquiryFields(variant);
      var mediaId = variant.featured_media && variant.featured_media.id;
      if (mediaId) showMedia(mediaId);
    }

    form.addEventListener('change', function (event) {
      if (!event.target.matches('[data-casa-option]')) return;
      update(findVariant());
    });

    var initialVariant = findVariant();
    if (initialVariant) syncInquiryFields(initialVariant);

    if (gallery) {
      gallery.casaShowMedia = showMedia;
      gallery.addEventListener('click', function (event) {
        if (event.target.closest('[data-gallery-previous]')) {
          moveMedia(-1);
          return;
        }

        if (event.target.closest('[data-gallery-next]')) {
          moveMedia(1);
          return;
        }

        var thumb = event.target.closest('.casa-gallery__thumb');
        if (!thumb) return;
        showMedia(thumb.getAttribute('data-media-id'));
      });

      var thumbs = gallery.querySelector('.casa-gallery__thumbs');
      if (thumbs) {
        thumbs.addEventListener('wheel', function (event) {
          if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
            event.preventDefault();
            thumbs.scrollLeft += event.deltaY;
          }
        }, { passive: false });
      }

      var stage = gallery.querySelector('.casa-gallery__stage');
      var touchStartX = 0;
      function moveMedia(direction) {
        var buttons = Array.from(gallery.querySelectorAll('.casa-gallery__thumb'));
        var current = buttons.findIndex(function (button) { return button.classList.contains('is-active'); });
        if (current < 0) current = 0;
        var next = (current + direction + buttons.length) % buttons.length;
        if (next !== current) showMedia(buttons[next].getAttribute('data-media-id'));
      }
      if (stage) {
        stage.addEventListener('touchstart', function (event) {
          touchStartX = event.changedTouches[0].clientX;
        }, { passive: true });
        stage.addEventListener('touchend', function (event) {
          var distance = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(distance) < 45) return;
          moveMedia(distance < 0 ? 1 : -1);
        }, { passive: true });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.casa-header');
    if (!header) return;

    var root = header.closest('.shopify-section-group-header-group') || header;
    var onScroll = function () {
      root.classList.toggle('is-compact', window.scrollY > 16);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-casa-pdp]');
    if (!root) return;

    var jsonEl = root.querySelector('[data-casa-product-json]');
    var form = root.querySelector('.casa-product-form');
    var gallery = root.querySelector('[data-casa-gallery]');
    if (!jsonEl || !form) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (error) {
      return;
    }

    var variantInput = form.querySelector('[data-casa-variant-id]');
    var skuEl = form.querySelector('[data-casa-sku]');
    var optionNames = product.options || [];

    function variantOptions(variant) {
      return variant.options || [variant.option1, variant.option2, variant.option3];
    }

    function selectedOptions() {
      return (product.options || []).map(function (_name, index) {
        var checked = form.querySelector(
          '[data-casa-option][data-option-position="' + (index + 1) + '"]:checked'
        );
        return checked ? checked.value : null;
      });
    }

    function findVariant() {
      var selected = selectedOptions();
      return (product.variants || []).find(function (variant) {
        var options = variantOptions(variant);
        return selected.every(function (value, index) {
          if (value == null) return true;
          return options[index] === value;
        });
      });
    }

    function optionValue(variant, name) {
      var needle = String(name || '').toLowerCase();
      var index = optionNames.findIndex(function (optionName) {
        return String(optionName || '').toLowerCase() === needle;
      });
      if (index < 0) return '';
      var options = variantOptions(variant);
      return options[index] || '';
    }

    function syncInquiryFields(variant) {
      var size = optionValue(variant, 'Size');
      var finish = optionValue(variant, 'Finish');
      var sku = variant.sku || '';
      var title = variant.title || '';
      if (title === 'Default Title') title = '';
      document.querySelectorAll('[data-casa-inquiry-field]').forEach(function (field) {
        var key = field.getAttribute('data-casa-inquiry-field');
        if (key === 'variant_title') field.value = title;
        if (key === 'sku') field.value = sku;
        if (key === 'size') field.value = size;
        if (key === 'finish') field.value = finish;
      });
      document.querySelectorAll('[data-casa-inquiry-display]').forEach(function (el) {
        var key = el.getAttribute('data-casa-inquiry-display');
        if (key === 'variant_title') el.textContent = title;
        if (key === 'size') el.textContent = size;
        if (key === 'finish') el.textContent = finish;
        if (key === 'sku') el.textContent = sku;
      });
      document.querySelectorAll('[data-casa-inquiry-row]').forEach(function (row) {
        var key = row.getAttribute('data-casa-inquiry-row');
        var value = '';
        if (key === 'variant_title') value = title;
        if (key === 'size') value = size;
        if (key === 'finish') value = finish;
        if (key === 'sku') value = sku;
        row.hidden = !value;
      });
    }

    function refreshOptionAvailability() {
      var selected = selectedOptions();
      form.querySelectorAll('[data-casa-option]').forEach(function (input) {
        var position = Number(input.getAttribute('data-option-position')) - 1;
        var value = input.value;
        var exists = false;
        var inStock = false;
        (product.variants || []).forEach(function (variant) {
          var options = variantOptions(variant);
          if (options[position] !== value) return;
          var matches = selected.every(function (sel, idx) {
            if (idx === position || sel == null) return true;
            return options[idx] === sel;
          });
          if (!matches) return;
          exists = true;
          if (variant.available) inStock = true;
        });
        var wrap = input.closest('.casa-product-form__value');
        input.disabled = false;
        if (wrap) {
          wrap.classList.remove('is-invalid');
          wrap.classList.remove('is-unavailable');
        }
      });
    }

    function showMedia(mediaId) {
      if (!gallery || !mediaId) return;
      gallery.querySelectorAll('.casa-gallery__slide').forEach(function (slide) {
        var active = String(slide.getAttribute('data-media-id')) === String(mediaId);
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      gallery.querySelectorAll('.casa-gallery__thumb').forEach(function (thumb) {
        var active = String(thumb.getAttribute('data-media-id')) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function update(variant) {
      refreshOptionAvailability();

      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;
      syncInquiryFields(variant);

      if (skuEl) {
        var template = skuEl.getAttribute('data-sku-template') || '';
        if (variant.sku) {
          skuEl.hidden = false;
          skuEl.textContent = template.replace('__SKU__', variant.sku);
        } else {
          skuEl.hidden = true;
        }
      }

      var mediaId = variant.featured_media && variant.featured_media.id;
      if (mediaId) showMedia(mediaId);
    }

    form.addEventListener('change', function (event) {
      if (!event.target.matches('[data-casa-option]')) return;
      update(findVariant());
    });

    refreshOptionAvailability();
    var initialVariant = findVariant();
    if (initialVariant) syncInquiryFields(initialVariant);

    if (gallery) {
      gallery.addEventListener('click', function (event) {
        var thumb = event.target.closest('.casa-gallery__thumb');
        if (!thumb) return;
        showMedia(thumb.getAttribute('data-media-id'));
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
